<h6 class="bar-info">
  <span>{{metric.label}}</span>
  <span class="{{ metric.color }}">{{metric.amount | currency}}</span>
</h6>

<app-progress-bar [value]="metric.percentage" [color]="metric.color"></app-progress-bar>

